import { get } from 'lodash';

import { Controller } from 'react-hook-form';

import { FormItem, Toggle, ToggleLayout } from '@ingrid/luterkort-react';

import { ValidateSchema } from '../../create/validate';
import { DynamicPath, useCarrierContractFormContext } from '../../types';
import { useTranslatedFormLabel } from '../hooks';
import { Schema } from '../queries';

interface Props {
  schemaId: string;
  schema: Schema;
  path?: string;
}

export function SchemaFormBoolean({ schemaId, path = '' }: Props) {
  const { formState, control } = useCarrierContractFormContext();

  const label = useTranslatedFormLabel({ path });

  return (
    <FormItem.Root>
      <Controller
        rules={ValidateSchema(path, schemaId)}
        name={path as DynamicPath}
        control={control}
        render={({ field }) => {
          return (
            <FormItem.Control invalid={!!get(formState.errors, path)?.message}>
              <ToggleLayout.Row>
                <Toggle onCheckedChange={val => field.onChange(val)} checked={!!field.value} aria-label={label} />
                <ToggleLayout.Stack>
                  <ToggleLayout.Label>{label}</ToggleLayout.Label>
                </ToggleLayout.Stack>
              </ToggleLayout.Row>
            </FormItem.Control>
          );
        }}
      />
    </FormItem.Root>
  );
}
